import script from "./associationNews.vue?vue&type=script&setup=true&lang=js"
export * from "./associationNews.vue?vue&type=script&setup=true&lang=js"

import "./associationNews.vue?vue&type=style&index=0&id=de839ffc&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de839ffc"]])

export default __exports__